export default __webpack_public_path__ + "static/media/Google_Play_Store_badge_EN.1d8f7bc8.svg";